import { computed } from '@vue/composition-api'
export const useDataSource = (list, footerNumber = 0) => {
  const dataList = computed(() => {
    if (!list.value) {
      return []
    }
    return Array.isArray(list.value) ? list.value : []
  })
  /**
   *
   *数据预处理
   * @param {*} [data=[]]
   * @param {number} [n=0]
   * @return array
   */
  const handleData = (data = [], n = 0) => {
    const num = n
    const len = data.length
    if (!num || num > len) {
      return [data, []]
    }
    return [data.slice(0, len - num), data.slice(-num)]
  }

  const bodyList = computed(() => {
    const res = handleData(dataList.value, footerNumber.value)
    return res[0] || []
  })
  const bottomList = computed(() => {
    const res = handleData(dataList.value, footerNumber.value)
    return res[1] || []
  })
  return {
    bodyList,
    bottomList
  }
}
